module.exports = {"440114001":"新华街道","440114002":"花城街道","440114003":"秀全街道","440114004":"新雅街道","440114103":"梯面镇","440114104":"花山镇","440114105":"花东镇","440114107":"炭步镇","440114108":"赤坭镇","440114109":"狮岭镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440114.json
// module id = 1952
// module chunks = 0